import { toast } from "sonner";

export function reportError(e: unknown) {
	toast.error("Failed to update task", {
		description: (e as Error).message || "Please try again.",
	});
}

export function copyToClipboard(text: string, label: string) {
	navigator.clipboard
		.writeText(text)
		.then(() => toast.success(`${label} copied`))
		.catch(() => toast.error("Failed to copy"));
}
